@use 'ui/styles/core-tokens' as core;

.info {
  &Item {
    display: flex;
    align-items: center;

    &Title {
      flex-shrink: 0;
      margin-right: 4px;
    }

    &Value {
      overflow: hidden;
      text-overflow: ellipsis;
      padding-left: 11px;
      padding-right: 11px;
      white-space: nowrap;
      width: auto;
    }

    a {
      text-decoration: underline;
    }
  }
}
